import { DialogCardBody, DialogCardFooter, Td, Tr, Row, Typography, ButtonGroup, ButtonText, Icon, InlineNote, InlineNoteIcon } from "@visa/vds"
import MCSPagedTable from "components/MCSPagedTable"
import React from "react"
import AnsweredRow from "./AnsweredRow"
import { GETTING_STARTED_DEFAULT_ANSWER, IMPLEMENTATION_TYPE_PRODUCTS, IMPLEMENTATION_TYPE_RESULT } from "_constants/CertificationTestingConstants"

const ResultDialog = (props) => {

    const {
        answers,
        certificationPackageAction,
        questionnaire,
        implementationType,
        implementationTypeState,
        product,
        setAnswers,
        setCompleted,
        setQuestionNumber,
        tableData
    } = props

    return (
        <>
            <DialogCardBody>
                <Typography className="getting-started-result-subheader " tag="h4" varian="subtitle"><b>Result</b></Typography>
                {implementationTypeState === IMPLEMENTATION_TYPE_RESULT.INVALID ?

                    <Row className="getting-started-bottom-border">
                        Your answer combination is not supported as an implementation type. Please retry.
                    </Row>
                    : implementationTypeState === IMPLEMENTATION_TYPE_RESULT.IRRELEVANT ?
                        <Row className="getting-started-bottom-border">
                            Great news that you are working with {product === IMPLEMENTATION_TYPE_PRODUCTS.ACS ? "an ACS" : "a 3DS Server"} hosting provider.
                            Contact your {product === IMPLEMENTATION_TYPE_PRODUCTS.ACS ? "ACS" : "3DS Server"} hosting provider if you have questions about {product === IMPLEMENTATION_TYPE_PRODUCTS.ACS ? "ACS" : "3DS Server"}  software certification.
                            The {product === IMPLEMENTATION_TYPE_PRODUCTS.ACS ? "ACS" : "3DS Server"}  hosting provider is responsible for certifying their software with Visa.</Row>
                        :
                        <>
                            <Row className="getting-started-bottom-border">
                                <InlineNote noteType="info">
                                    <p>Your implementation type is <b className="visa-blue">{`${implementationType.label} (${implementationType.typeId})`}</b>.</p>
                                </InlineNote>
                                <br />
                                You have answered the following for your <b>{product === IMPLEMENTATION_TYPE_PRODUCTS.ACS ? "ACS" : "3DS Server"}</b> implementation.
                                <br />
                                <br />
                                {questionnaire && questionnaire.map((question, questionId) =>
                                    <Row className="getting-started-result-set getting-started-question-set" >
                                        <AnsweredRow answer={question.answers.find(ans => ans.value === answers[questionId + 1])} question={question} questionId={questionId} />
                                    </Row>
                                )}
                                <br />
                            </Row>
                            <Row className="getting-started-bottom-border">
                                <br />
                                <Typography className="getting-started-result-subheader" tag="h4" varian="subtitle"><b>Prerequisites</b></Typography>

                                You will need to show the following items to your Visa Secure test analyst to begin certification process.
                                <MCSPagedTable
                                    size={"compact"}
                                    colHeaders={[{
                                        displayName: "Item",
                                        name: "Item",
                                        orderable: false,
                                    },
                                    {
                                        displayName: "Remarks",
                                        name: "Remarks",
                                        orderable: false,
                                    },
                                    ]}
                                    tableData={tableData.map((row, key) => (
                                        <Tr key={key}>
                                            <Td>{row.item}</Td>
                                            <Td>{row.remark}</Td>
                                        </Tr>
                                    ))
                                    }
                                />
                            </Row>
                        </>
                }
            </DialogCardBody>
            <DialogCardFooter>
                <ButtonGroup direction="right">
                    <ButtonText
                        className="getting-started-button"
                        colorScheme="primary"
                        id="getting-started-reset-button"
                        onClick={() => {
                            setAnswers(GETTING_STARTED_DEFAULT_ANSWER())
                            setQuestionNumber(1)
                            setCompleted(false)
                        }}
                    >
                        Reset
                    </ButtonText>
                    {certificationPackageAction && implementationTypeState === IMPLEMENTATION_TYPE_RESULT.VALID &&
                        <ButtonText
                            className="getting-started-button"
                            colorScheme="primary"
                            id="getting-started-reset-button"
                            onClick={() => {
                                certificationPackageAction(implementationType.id)
                            }}
                        >
                            Use this Implementation Type
                        </ButtonText>
                    }
                </ButtonGroup>
            </DialogCardFooter>
        </>
    )
}

export default ResultDialog